import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import LeadForm from '../components/LeadForm';
import { FAQS } from '../constants/content';

export default function FaqPage() {
  return (
    <main>
      <section className="policy__hero">
        <div className="shell">
          <p className="policy__crumbs">
            <Link to="/">Home</Link>
            <span aria-hidden="true"> / </span>
            <span>FAQs</span>
          </p>
          <h1>Frequently asked questions</h1>
          <p className="policy__updated">
            The questions we are asked most before a first diagnosis
          </p>
        </div>
      </section>

      <section className="section">
        <div className="shell consult">
          <div className="consult__copy">
            <ul className="faq">
              {FAQS.map((item) => (
                <li key={item.q}>
                  <h3>
                    <Icon name="spark" size={16} />
                    {item.q}
                  </h3>
                  <p>{item.a}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="consult__form">
            <LeadForm
              variant="full"
              title="Still have a question?"
              subtitle="Send it over and we will answer by email."
              cta="Send my question"
              formName="faq"
            />
          </div>
        </div>
      </section>
    </main>
  );
}
